import loadPreferencesUI from './events/loadPreferencesUI';
import loadConfirmUI from './events/loadConfirmUI';
import { setPreLoadStyles, resetPreLoadStyles, setConfirmationPreLoadStyles } from './events/managePreLoadStyles';
import loadArchivedSubscription from './events/loadArchivedSubscription';
import loadResubContainer from './events/loadResubContainer';
import loadSubscriptionDefinitions from './events/loadSubscriptionDefinition';
import addFormSubmissionListeners from './listeners/formSubmission';
import addLanguageSelectorListeners from './listeners/languageSelector';
import addUnsubscribeAllListeners from './listeners/unsubscribeAll';
import addConfirmationListeners from './listeners/confirmation';
import { loadPreferences } from './api/preferences';
import { getPathSuffix } from './utils/url';
import filterLanguageSelectorOptions from './events/filterLanguageSelectorOptions';
import loadSingleSubscriptionUI from './events/loadSingleSubscriptionUI';
export default class CmsWorker {
  constructor() {
    const suffix = getPathSuffix();
    this.isDOIConfirm = suffix === 'optin-confirmed';
    this.isConfirm = suffix === 'confirm';
    this.isPage = suffix === 'page';
    this.isSingle = suffix === 'single';
  }
  getConfirmWorker() {
    return async function () {
      const response = await loadPreferences();
      loadConfirmUI(response);
      addConfirmationListeners();
      resetPreLoadStyles();
      document.dispatchEvent(new Event('hsCMSLoadComplete'));
    };
  }
  getPageWorker() {
    const isPage = this.isPage;
    return async function () {
      const response = await loadPreferences();
      loadPreferencesUI(response);
      loadSubscriptionDefinitions(response);
      isPage && loadResubContainer(response);
      loadArchivedSubscription(response);
      addLanguageSelectorListeners();
      filterLanguageSelectorOptions(response);
      addUnsubscribeAllListeners();
      resetPreLoadStyles();
      addFormSubmissionListeners();
      document.dispatchEvent(new Event('hsCMSLoadComplete'));
    };
  }
  getSingleWorker() {
    return async function () {
      const response = await loadPreferences();
      loadSingleSubscriptionUI(response);
      addFormSubmissionListeners();
      resetPreLoadStyles();
      document.dispatchEvent(new Event('hsCMSLoadComplete'));
    };
  }
  async init() {
    if (this.isConfirm || this.isDOIConfirm) {
      setConfirmationPreLoadStyles();
      return this.getConfirmWorker();
    }
    if (this.isSingle) {
      setPreLoadStyles();
      return this.getSingleWorker();
    }
    setPreLoadStyles();
    return this.getPageWorker();
  }
}